import {currentEnv} from "../../Const";

export const SangerQCPipeline = {
    Status: {
        IN_PROGRESS: "In progress",
        FAILED: "Failed",
        COMPLETED: "Completed",
    }
}

export const sangerQcApiConsts = {
    API_NAME: "sangerqcpipelines", // This name needs to be the same as the name of the API in the App.tsx file
    Path: {
        LIST_ALL: "/sangerqcpipelines/all",
        BASE: "/sangerqcpipelines",
        REPORT: "/sangerqcpipelines/result",
    }
}